export function intiSliderGutter(){
    function updateSwiperOffsets(): void {
        const container = document.querySelector<HTMLElement>('.container');
        const swiperBlocks = document.querySelectorAll<HTMLElement>('.swiper-main');

        if (!container || swiperBlocks.length === 0) return;

        const windowWidth: number = window.innerWidth;
        const containerWidth: number = container.offsetWidth;

        // Берём padding-right у .container
        const containerStyles = getComputedStyle(container);
        const containerPaddingRight: number = parseFloat(containerStyles.paddingRight) || 0;

        // Отступ справа/слева + padding контейнера
        const gutter: number = Math.max((windowWidth - containerWidth) / 2, 0) + containerPaddingRight - 10;

        swiperBlocks.forEach((el) => {
            el.style.marginRight = `-${gutter}px`;
            el.style.paddingRight = `${gutter}px`;
        });
    }

// Первоначальный вызов
    updateSwiperOffsets();

// Пересчёт при ресайзе
    window.addEventListener('resize', updateSwiperOffsets);

}